import React from 'react';
import { NavLink } from 'o2web-react-core';
import PropTypes from 'prop-types';

import './styles.scss';

import logoDesktop from '../../../../assets/images/logo_desktop.svg';
import logoMobile from '../../../../assets/images/logo_mobile.svg';
import SiteNav from './SiteNav';

const contextTypes = {
  t: PropTypes.func,
};

function Header(props, { t }) {
  return (
    <header className="page-header">
      <h1 className="page-header__logo">
        <NavLink to="/fr">
          <picture>
            <source srcSet={logoMobile} media="(max-width: 1120px)" className="mobile" />
            <img srcSet={logoDesktop} alt={t('pages.home.title')} />
          </picture>
        </NavLink>
      </h1>
      <SiteNav />
    </header>
  );
}

Header.contextTypes = contextTypes;

export default Header;



// WEBPACK FOOTER //
// ./src/app/components/layouts/header/Header.js